// removed by extract-text-webpack-plugin
module.exports = {"Header":"header__Header__dXJAR","Logo":"header__Logo__1FOBe","NavItem":"header__NavItem__1pWsn","MenuToggle":"header__MenuToggle__Q4YgP","Menu":"header__Menu__poCvN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Header/header.css
// module id = 151
// module chunks = 0